// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"290f62ba","339":"6d520acc","342":"2f34075e","355":"f3bd1ae9","453":"26fefb40","455":"54090c53","586":"ca168689","631":"d4654b9e","951":"8bb2ebb3","977":"6d13b6a5"}[chunkId] + ".chunk.js";
};